import _ from "lodash";
import {
  CREATE_NEW_CUSTOM_SLOT_TYPE,
  LIST_CUSTOM_SLOT_TYPES,
  CLEAR_LIST_OF_CUSTOM_SLOT_TYPES,
  DELETE_CUSTOM_SLOT_TYPE,
  GENERATE_SKILL_BUILDER_CODE,
  CLEAR_DELETE_CUSTOM_SLOT_TYPE_RESPONSE,
  CLEAR_CREATED_CUSTOM_SLOT_TYPE_RESPONSE,
  UPDATE_CUSTOM_SLOT_TYPE,
  CLEAR_UPDATE_CUSTOM_SLOT_TYPE_RESPONSE,
  CLEAR_ALL_CUSTOM_SLOTS_STATE
} from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case LIST_CUSTOM_SLOT_TYPES:
      return {
        ...state,
        listCustomSlotTypesResponse: action.payload.response
      };
    case CREATE_NEW_CUSTOM_SLOT_TYPE:
      return {
        ...state,
        createNewCustomSlotTypeResponse: action.payload.response
      };
    case CLEAR_LIST_OF_CUSTOM_SLOT_TYPES:
      return _.omit(state, ["listCustomSlotTypesResponse"]);
    case DELETE_CUSTOM_SLOT_TYPE:
      return {
        ...state,
        deleteCustomSlotTypeResponse: action.payload.response
      };
    case UPDATE_CUSTOM_SLOT_TYPE:
      return {
        ...state,
        updateCustomSlotTypeResponse: action.payload.response
      };
    case GENERATE_SKILL_BUILDER_CODE:
      return {
        ...state,
        generateSkillBuilderCodeResponse: action.payload.response
      };
    case CLEAR_DELETE_CUSTOM_SLOT_TYPE_RESPONSE:
      return _.omit(state, ["deleteCustomSlotTypeResponse"]);
    case CLEAR_CREATED_CUSTOM_SLOT_TYPE_RESPONSE:
      return _.omit(state, ["createNewCustomSlotTypeResponse"]);
    case CLEAR_UPDATE_CUSTOM_SLOT_TYPE_RESPONSE:
      return _.omit(state, ["updateCustomSlotTypeResponse"]);
    case CLEAR_ALL_CUSTOM_SLOTS_STATE:
      return {};
    default:
      return state;
  }
};
